/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */

import request from '@/router/axios'

export function fetchPage(query) {
  return request({
    url: '/music/agent/page',
    method: 'get',
    params: query
  })
}

export function fetchList(query) {
  return request({
    url: '/admin/tenant/list',
    method: 'get',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/admin/tenant',
    method: 'post',
    data: obj
  })
}

export function addAgentObj(obj) {
  return request({
    url: '/music/agent',
    method: 'post',
    data: obj
  })
}

export function editAgentObj(obj) {
  return request({
    url: '/music/agent',
    method: 'put',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/admin/tenant/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/admin/tenant/' + id,
    method: 'delete'
  })
}

// 删除代理商
export function delAgentObj(id) {
  return request({
    url: '/music/agent/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/admin/tenant',
    method: 'put',
    data: obj
  })
}

// 导出
export function downloadTenant(obj) {
  return request({
    url: '/music/agent/download/agent',
    method: 'post',
    timeout: 5 * 60 * 1000,
    responseType: 'blob',
    data: obj
  })
}

// 用户/角色 - 同步到承办方
export function updateTenant() {
  return request({
    url: '/music/common/syn/menu',
    method: 'put',
  })
}

// 字典 - 同步到承办方
export function updateDict() {
  return request({
    url: '/music/common/syn/dict',
    method: 'put',
  })
}
